module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-bg-2-bb04724590c7ff996a008a6ab0c2d4ec.png";